import { axios } from "../config/axios";

const endPoint = '/project/dashboard';

const getAvailableData = async () => {
    return axios.get(`${endPoint}/get-available-data`);
}

const getDashboardStats = async (body) => {
    return axios.post(`${endPoint}/dashboard-stats`, body);
}

export {
    getAvailableData,
    getDashboardStats,
}